module.exports = __webpack_public_path__ + "media/7.22ca1252.wav";